(function () {
  var BLOCKED_CLASS = "participant-form-blocked";

  function updateCombinedCheckboxValue(group) {
    var hiddenInput = group.querySelector("[data-line-item-combined]");
    if (!hiddenInput) return;

    var propertyName = group.getAttribute("data-property-name");
    var values = [];

    group.querySelectorAll("[data-line-item-checkbox]:checked").forEach(function (checkbox) {
      if (checkbox.value) values.push(checkbox.value);
    });

    if (values.length) {
      hiddenInput.name = "properties[" + propertyName + "]";
      hiddenInput.value = values.join(", ");
      hiddenInput.disabled = false;
    } else {
      hiddenInput.value = "";
      hiddenInput.disabled = true;
      hiddenInput.removeAttribute("name");
    }
  }

  function hasRequiredFields(root) {
    return !!root.querySelector("[required], [data-line-item-checkbox-required='true']");
  }

  function validateRoot(root, showErrors) {
    if (!hasRequiredFields(root)) return true;

    var valid = true;

    root.querySelectorAll("textarea[required], select[required], input[required]").forEach(function (field) {
      if (field.type === "hidden") return;

      var fieldValid = field.value.trim() !== "";
      var wrapper = field.closest(".form-field");

      if (wrapper && showErrors) {
        wrapper.classList.toggle("invalid", !fieldValid);
        field.classList.toggle("form-control--warning", !fieldValid);
      }

      if (!fieldValid) valid = false;
    });

    root.querySelectorAll("[data-line-item-checkbox-required='true']").forEach(function (group) {
      var groupValid = !!group.querySelector("[data-line-item-checkbox]:checked");

      if (showErrors) {
        group.classList.toggle("invalid", !groupValid);
      }

      if (!groupValid) valid = false;
    });

    return valid;
  }

  function getPurchaseTargets(formId, sectionId) {
    var targets = {
      buyButtons: [],
      dynamicBuy: [],
      appBlocks: [],
    };

    if (formId) {
      targets.buyButtons = Array.prototype.slice.call(
        document.querySelectorAll(
          "#" +
            formId +
            ' button[type="submit"].f-product-form__submit, button[type="submit"][form="' +
            formId +
            '"]:not(.btn--loading)'
        )
      );
    }

    var productInfo = document.getElementById("ProductInfo-" + sectionId);
    if (productInfo) {
      targets.dynamicBuy = Array.prototype.slice.call(
        productInfo.querySelectorAll(".f-product-form__button-dynamic")
      );
      targets.appBlocks = Array.prototype.slice.call(productInfo.querySelectorAll(".f-product__app-block"));
    }

    return targets;
  }

  function setPurchaseBlocked(blocked, formId, sectionId) {
    var targets = getPurchaseTargets(formId, sectionId);

    targets.buyButtons.forEach(function (button) {
      button.disabled = blocked;
      button.classList.toggle(BLOCKED_CLASS, blocked);
      button.setAttribute("aria-disabled", blocked ? "true" : "false");
    });

    targets.dynamicBuy.forEach(function (button) {
      button.classList.toggle(BLOCKED_CLASS, blocked);
      button.setAttribute("aria-hidden", blocked ? "true" : "false");
    });

    targets.appBlocks.forEach(function (block) {
      block.classList.toggle(BLOCKED_CLASS, blocked);
      block.setAttribute("aria-disabled", blocked ? "true" : "false");
    });
  }

  function refreshValidation(root) {
    if (!root) return true;

    var formId = root.getAttribute("data-form-id");
    var sectionId = root.getAttribute("data-section-id");
    var valid = validateRoot(root, true);

    setPurchaseBlocked(!valid, formId, sectionId);
    return valid;
  }

  function initCheckboxGroups(root) {
    root.querySelectorAll("[data-line-item-checkbox-group]").forEach(function (group) {
      if (group.dataset.checkboxBound === "1") return;

      updateCombinedCheckboxValue(group);

      group.querySelectorAll("[data-line-item-checkbox]").forEach(function (checkbox) {
        checkbox.addEventListener("change", function () {
          updateCombinedCheckboxValue(group);
          refreshValidation(root);
        });
      });

      group.dataset.checkboxBound = "1";
    });
  }

  function initValidationListeners(root, form) {
    if (!root || root.dataset.validationListenersBound === "1") return;

    root.querySelectorAll("textarea, select, input").forEach(function (field) {
      if (field.type === "hidden" || field.type === "checkbox") return;

      field.addEventListener("input", function () {
        refreshValidation(root);
      });
      field.addEventListener("change", function () {
        refreshValidation(root);
      });
    });

    if (form && form.dataset.participantFormSubmitBound !== "1") {
      form.addEventListener("submit", function (event) {
        document.querySelectorAll("[data-participant-form]").forEach(function (participantRoot) {
          if (!refreshValidation(participantRoot)) {
            event.preventDefault();

            var firstInvalid = participantRoot.querySelector(
              ".form-field.invalid, [data-line-item-checkbox-group].invalid"
            );
            if (firstInvalid) {
              firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
            }
          }
        });
      });

      form.dataset.participantFormSubmitBound = "1";
    }

    root.dataset.validationListenersBound = "1";
  }

  function watchPurchaseTargets(root) {
    var sectionId = root.getAttribute("data-section-id");
    var productInfo = document.getElementById("ProductInfo-" + sectionId);
    if (!productInfo || productInfo.dataset.participantFormTargetObserver === "1") return;

    var observer = new MutationObserver(function () {
      refreshValidation(root);
    });

    observer.observe(productInfo, { childList: true, subtree: true });
    productInfo.dataset.participantFormTargetObserver = "1";
  }

  function getQuantityInput(root) {
    var sectionId = root.getAttribute("data-section-id");
    var productId = root.getAttribute("data-product-id");
    return document.getElementById("Quantity-" + sectionId + "-" + productId);
  }

  function getTargetQuantity(root) {
    var quantityInput = getQuantityInput(root);
    if (!quantityInput) return 1;

    var qty = parseInt(quantityInput.value, 10);
    if (isNaN(qty) || qty < 1) return 1;
    return qty;
  }

  function getFieldTitleFromPropertyName(propertyName) {
    var separatorIndex = propertyName.indexOf(" - ");
    if (separatorIndex === -1) return propertyName;
    return propertyName.substring(separatorIndex + 3);
  }

  function updateInstanceTokens(instance, index, participantLabel, sectionId) {
    var heading = participantLabel + " " + index;

    instance.setAttribute("data-participant-index", String(index));

    var headingEl = instance.querySelector(".participant-form__heading");
    if (headingEl) headingEl.textContent = heading;

    instance.querySelectorAll("[id]").forEach(function (el) {
      el.id = el.id.replace(/__INDEX__/g, String(index)).replace(
        new RegExp("participant-" + sectionId + "-\\d+-"),
        "participant-" + sectionId + "-" + index + "-"
      );
    });

    instance.querySelectorAll("label[for]").forEach(function (label) {
      var targetId = label.getAttribute("for");
      if (!targetId) return;
      label.setAttribute(
        "for",
        targetId.replace(/__INDEX__/g, String(index)).replace(
          new RegExp("participant-" + sectionId + "-\\d+-"),
          "participant-" + sectionId + "-" + index + "-"
        )
      );
    });

    instance.querySelectorAll("[name^='properties[']").forEach(function (field) {
      var name = field.getAttribute("name") || "";
      var match = name.match(/^properties\[(.*)\]$/);
      if (!match) return;

      var fieldTitle = getFieldTitleFromPropertyName(match[1].replace(/__INDEX__/g, String(index)));
      field.setAttribute("name", "properties[" + heading + " - " + fieldTitle + "]");
    });

    instance.querySelectorAll("[data-property-name]").forEach(function (el) {
      var current = (el.getAttribute("data-property-name") || "").replace(/__INDEX__/g, String(index));
      var fieldTitle = getFieldTitleFromPropertyName(current);
      el.setAttribute("data-property-name", heading + " - " + fieldTitle);
    });
  }

  function createInstanceFromTemplate(root, index) {
    var template = root.querySelector("[data-participant-form-template]");
    if (!template || !template.content || !template.content.firstElementChild) return null;

    var participantLabel = root.getAttribute("data-participant-label") || "Participant";
    var sectionId = root.getAttribute("data-section-id");
    var clone = template.content.firstElementChild.cloneNode(true);

    updateInstanceTokens(clone, index, participantLabel, sectionId);
    return clone;
  }

  function resetFieldBindings(root) {
    root.dataset.validationListenersBound = "0";
    root.querySelectorAll("[data-line-item-checkbox-group]").forEach(function (group) {
      delete group.dataset.checkboxBound;
    });
  }

  function syncParticipantForms(root) {
    var container = root.querySelector("[data-participant-forms-container]");
    if (!container) return;

    var targetQty = getTargetQuantity(root);
    var instances = Array.prototype.slice.call(container.querySelectorAll("[data-participant-instance]"));

    while (instances.length < targetQty) {
      var newInstance = createInstanceFromTemplate(root, instances.length + 1);
      if (!newInstance) break;
      container.appendChild(newInstance);
      instances.push(newInstance);
    }

    while (instances.length > targetQty) {
      var removed = instances.pop();
      if (removed && removed.parentNode) {
        removed.parentNode.removeChild(removed);
      }
    }

    resetFieldBindings(root);

    var formId = root.getAttribute("data-form-id");
    var form = document.getElementById(formId);

    initCheckboxGroups(root);
    initValidationListeners(root, form);
    refreshValidation(root);
  }

  function bindQuantityListener(root) {
    var quantityInput = getQuantityInput(root);
    if (!quantityInput || quantityInput.dataset.participantFormQtyBound === "1") return;

    var sync = function () {
      syncParticipantForms(root);
    };

    quantityInput.addEventListener("change", sync);
    quantityInput.addEventListener("input", sync);

    var quantityWrapper = quantityInput.closest("quantity-input");
    if (quantityWrapper) {
      quantityWrapper.querySelectorAll("button").forEach(function (button) {
        button.addEventListener("click", function () {
          window.setTimeout(sync, 0);
        });
      });
    }

    quantityInput.dataset.participantFormQtyBound = "1";
  }

  function initParticipantForm(root) {
    if (!root || root.dataset.participantFormInitialized === "1") return;

    var formId = root.getAttribute("data-form-id");
    var form = document.getElementById(formId);

    bindQuantityListener(root);
    syncParticipantForms(root);
    watchPurchaseTargets(root);

    root.dataset.participantFormInitialized = "1";
  }

  function initAll() {
    document.querySelectorAll("[data-participant-form]").forEach(initParticipantForm);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (!event.target) return;
    event.target.querySelectorAll("[data-participant-form]").forEach(function (root) {
      root.dataset.participantFormInitialized = "0";
      initParticipantForm(root);
    });
  });
})();
